import * as React from "react";
const SvgBarChart01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.965 20v-6a1.035 1.035 0 0 1 2.07 0v6a1.035 1.035 0 0 1-2.07 0m6 0V4a1.035 1.035 0 0 1 2.07 0v16a1.035 1.035 0 0 1-2.07 0m6 0V10a1.035 1.035 0 0 1 2.07 0v10a1.035 1.035 0 0 1-2.07 0"
}));
export default SvgBarChart01;
//# sourceMappingURL=BarChart01.js.map